import React, { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import EmptyState from "../Questions/components/EmptyState"
import AssessorEmpty from "./components/AssessorEmpty"
import AssessorFilters from "./components/AssessorFilters"
import AssessorHeader from "./components/AssessorHeader"
import AssessorPagination from "./components/AssessorPagination"
import PaperAssessmentCard from "./components/PaperAssessmentCard"
import QuestionAssessmentCard from "./components/QuestionAssessmentCard"
import useAssessmentFeed from "./hooks/useAssessmentFeed"
import "./AiAssessorPage.style.scss"

const AiAssessorPage = () => {
  const feed = useAssessmentFeed()
  const [searchParams] = useSearchParams()
  const attemptId = searchParams.get("attempt")

  useEffect(() => {
    if (!attemptId) return
    feed.setFilter("all")
    feed.setSubject("")
    feed.setTopic("")
  }, [attemptId, feed.setFilter, feed.setSubject, feed.setTopic])

  const hasAny = feed.summary.total > 0

  return (
    <div className="ai-assessor-page">
      <div className="ai-assessor-page__inner">
        <AssessorHeader
          total={feed.summary.total}
          questionCount={feed.summary.questions}
          paperCount={feed.summary.papers}
        />

        {feed.loading && !hasAny && !feed.records.length && (
          <EmptyState title="Loading assessments…" />
        )}

        {!feed.loading && feed.error && !feed.records.length && (
          <EmptyState
            title="Couldn’t load assessments"
            description={feed.error}
          />
        )}

        {hasAny && (
          <AssessorFilters
            filter={feed.filter}
            sort={feed.sort}
            subject={feed.subject}
            topic={feed.topic}
            total={feed.filtered.total}
            questionCount={feed.filtered.questions}
            paperCount={feed.filtered.papers}
            subjects={feed.subjects}
            topics={feed.topics}
            onFilter={feed.setFilter}
            onSort={feed.setSort}
            onSubject={feed.setSubject}
            onTopic={feed.setTopic}
          />
        )}

        {!feed.loading && !feed.error && hasAny && feed.records.length === 0 && (
          <AssessorEmpty filter={feed.filter} />
        )}

        {feed.records.length > 0 && (
          <div className="ai-assessor-page__list">
            {feed.records.map((record) =>
              record.kind === "question" ? (
                <QuestionAssessmentCard
                  key={record.id}
                  record={record}
                  startExpanded={record.id === attemptId}
                />
              ) : (
                <PaperAssessmentCard key={record.id} record={record} />
              )
            )}
          </div>
        )}

        <AssessorPagination
          pagination={feed.pagination}
          loading={feed.loading}
          onPageChange={feed.setPage}
        />
      </div>
    </div>
  )
}

export default AiAssessorPage
